import React from 'react'
import classNames from 'classnames'
import base from './base.module.css'
import styles from './Normal.module.css'

export default () => (
  <div className={classNames(base.container, styles.container)} />
)
